//1.引入vue
// import Vue from 'vue'
//2.引入axios库
import axios from 'axios';
import store from '../store/index';
import router from './../router';
import { ElMessage } from 'element-plus';
import _ from 'lodash';
import i18n from '@/main';

// const { t } = useI18n()
// let i18n = useI18n();
// loading对象
let ElLoading;
// 当前正在请求的数量
let needLoadingRequestCount = 0;

// const baseURL =
//   process.env.NODE_ENV == "development"
//     ? // ? "/dev" // 目标测试地址
//       "https://famikeep-test.afirstsoft.cn/api/"
//     : "https://my.famikeep.com/api/";
// const baseURL = 'https://my.famikeep.com/api/';
const baseURL = 'https://famikeep-test.afirstsoft.cn/api/';
// const baseURL = "http://192.168.6.26:8000/api/";

const service = axios.create({
  baseURL,
  timeout: 10 * 1000,
});
// 2.请求拦截器
service.interceptors.request.use(
  (config) => {
    // 发请求前做的一些处理，数据转化，配置请求头，设置token,设置loading等，根据需求去添加
    // 数据转化,也可以使用qs转换
    config.data = JSON.stringify(config.data);
    // config.data = true
    config.headers = {
      'Content-Type': 'application/json', // 配置请求头
      // "X-Oss-Object-Acl": "public-read",
      authorization: localStorage.getItem('authorization'),
      // authorization: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2NjY3NTQzODMsImlhdCI6MTY2NDE2MjM4Mywic2Vzc2lvbl9pZCI6IjYzMzExYTRmNWNjM2YzNmQwYmQwNjhiOCJ9.z6Gu8xnCea8izUQu9xeY6fK33LgEcz9wjy9QCjBcp6o",
    };
    return config;
  },
  (error) => {
    store.state.overLoading = false;
    ElMessage.error('You are out of networker');
    Promise.reject(error);
  }
);

// 3.响应拦截器
service.interceptors.response.use(
  (response) => {
    console.log('response', response);
    if (response.data.code != 200) {
      // console.log("responsedatacode", response.data.code);
      // switch (response.data.code) {
      //   case 400200:
      //     ElMessage.error(i18n.global.t("invalidPasswordFormat"));
      //     break;
      //   case 401400:
      //     ElMessage.error(i18n.global.t("theEmailHasRegistered"));
      //     break;
      //   case 400302:
      //     ElMessage.error(i18n.global.t("incorrectVerifiCode"));
      //     break;
      //   case 400301:
      //     ElMessage.error(i18n.global.t("verificationCodeGetAgain"));
      //     break;
      //   case 400205:
      //     ElMessage.error(i18n.global.t("erificationCodeMatch"));
      //     break;
      //   case 404001:
      //     ElMessage.error(i18n.global.t("emailRegistered"));
      //     break;
      //   case 400201:
      //     ElMessage.error(i18n.global.t("incorrectPasswordOrEmail"));
      //     break;
      //   case 400206:
      //     ElMessage.error(i18n.global.t("passwordNotold"));
      //     break;
      //   case 400103:
      //     ElMessage.error(i18n.global.t("pleaseTryAgainLater"));
      //     break;
      //   default:
      //   // ElMessage.error(response.data.msg);
      //   // ElMessage.error("登录失败");
      // }
    } else {
    }

    // 如果是登录失效，则清除本地存储中的用户信息，同时保存email用于自动填充登录框的用户名
    if (
      response.data.code == 401 &&
      response.data.data.reason == 'INACTIVE_EXPIRED'
    ) {
      localStorage.removeItem('authorization');
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '0');
      const email = userInfo.email;
      localStorage.setItem('email', JSON.stringify(email));
      localStorage.removeItem('userInfo');
      localStorage.removeItem('user_id');
      store.dispatch('setLoginStatus', false);
      store.commit('setIsLoginExpired', true);
    }
    store.state.overLoading = false;
    return response;
  },
  (error) => {
    store.state.overLoading = false;
    /** *** 接收到异常响应的处理开始 *****/
    if (error && error.response) {
      console.log('error:', error);

      // 1.公共错误处理
      // 2.根据响应码具体处理
      // console.log("error.response.status", error.response.status);

      switch (error.response.data.code) {
        case 401001:
          // 当密码发生修改或者token失效，其他地方就退出登录
          // ElMessage.error("Unauthorized, please login first!");
          localStorage.removeItem('authorization');
          localStorage.removeItem('userInfo');
          localStorage.removeItem('user_id');
          store.commit('setModalStatus', '1');
          store.commit('setLoginStatus', false);
          localStorage.removeItem('token');
          store.commit('setHashValue', null);
          // 清空vuex的缓存
          store.commit('getUserInfo', {});
          store.commit('getDeviceInfo', []);
          store.commit('setSubscripts', {});
          store.commit('setCurrentDeviceInfo', {});
          store.commit('setCurrentDeviceId', 0);

          router.go(0);
          break;
        case 401003:
          // 登录过期;
          store.commit('setMessageToastType', 4);
          if (!window.location.href.includes('home')) {
            router.push({ path: '/iosLogin' });
            store.commit('setDefaultMenu', null);
          }
        case 400:
          ElMessage.error(i18n.global.t('requestError'));
          break;
        case 403:
          ElMessage.error(i18n.global.t('accessDenied'));
          break;
        case 404:
          ElMessage.error(i18n.global.t('requestErrorResourceNotFound'));
          break;
        case 408:
          ElMessage.error(i18n.global.t('requestTimedOut'));
          break;
        case 500:
          ElMessage.error(i18n.global.t('serverError'));
          break;
        case 502:
          ElMessage.error(i18n.global.t('connectionServerFailed'));
          break;
        case 503:
          ElMessage.error(i18n.global.t('serviceUnavailable'));
          break;
        case 504:
          ElMessage.error(i18n.global.t('networkAbnormaled'));
          break;
        case 505:
          ElMessage.error(i18n.global.t('httpVersioSupportTheRequest'));
          break;
        //   default:
        //     ElMessage.error(error.response.status);
      }
    } else {
      // 超时处理
      // ElMessage.error(i18n.global.t("networkAbnormal"));
      ElMessage.error(i18n.global.t('networkAbnormaled'));
    }
    console.log('error:', error);
    /** *** 处理结束 *****/
    // 如果不需要错误处理，以上的处理过程都可省略
    return Promise.resolve(error.response);
  }
);

// 4.导入文件
export default service;
